import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "editor", "source", "toggle"]

  toggle() {
    const showSource = this.sourceTarget.hidden
    if (showSource) {
      this.sourceTarget.value = this.inputTarget.value
    } else {
      this.editorTarget.editor.loadHTML(this.sourceTarget.value)
    }
    this.sourceTarget.hidden = !showSource
    this.editorTarget.hidden = showSource
    this.editorTarget.toolbarElement.hidden = showSource
    this.toggleTarget.textContent = showSource ? "Редактор" : "HTML"
    this.toggleTarget.setAttribute("aria-expanded", String(showSource))
    const focusTarget = showSource ? this.sourceTarget : this.editorTarget
    focusTarget.focus()
  }

  syncSource() {
    this.inputTarget.value = this.sourceTarget.value
  }

  rejectFile(event) {
    event.preventDefault()
  }

  rejectAttachment(event) {
    event.attachment.remove()
  }
}
